<template>
        <div class="col-1.5 m-3" >
   <span >
<select class="custom-select"
id="input"
      v-on:input="$emit('input', $event.target.value)">
<option :value=null selected>Filtra per stato</option>
  <option v-for="stat in status"
          :key="stat"
          :value="stat"
          >
          <span >{{lower(stat)}}</span>
          </option>
</select>
</span>
          </div>
</template>

<script>

export default {
  name: 'filtroStato',
  props: ['value'],
  data () {
    return {
      status: ['NON_VERIFICATA', 'VERIFICATA', 'IN_CODA', 'IN_CARICO', 'RISOLTA', 'RIFIUTATA', 'ARCHIVIATA']
    }
  },
  methods: {

    lower (s) {
      var news = s.toLowerCase()
      var last = news.replace(/_/g, ' ')
      return last
    }
  }
}
</script>
